import z from "zod"

export function initZodI18n() {
  z.config({
    customError: (iss) => {
      if (iss.message) {
        return iss.message
      }
      if (
        iss.code === "too_small" &&
        (iss.origin === "number" ||
          iss.origin === "bigint" ||
          iss.origin === "int")
      ) {
        return `$t(common:form.errors.greater_or_equal, {"count": ${iss.minimum} })`
      }
      if (
        iss.code === "too_big" &&
        (iss.origin === "number" ||
          iss.origin === "bigint" ||
          iss.origin === "int")
      ) {
        return `$t(common:form.errors.less_or_equal, {"count": ${iss.maximum} })`
      }
      if (iss.code === "invalid_type") {
        return `common:form.errors.empty`
      }
      if (iss.code === "invalid_value") {
        return `common:form.errors.empty`
      }
      if (iss.code === "invalid_format") {
        if (
          iss.format === "datetime" ||
          iss.format === "date" ||
          iss.format === "time"
        ) {
          return `common:form.errors.empty`
        }
        if (iss.format === "email") {
          return `common:form.errors.email`
        }
        if (iss.format === "e164") {
          return `common:form.errors.phone`
        }
        if (iss.format === "url") {
          return `common:form.errors.domain`
        }
      }
      return `common:form.errors.empty`
    },
  })
}
